import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';


class ShopsMenu extends Component {

    constructor() {
        super();
        if (!Comm.ValidSession())
            return;

        this.state = {
            Translation: Translation
        };
    }


    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        if (Context.RenderNotOK(this.props.history))
            return null;

        return (
            <div className="btn-toolbar">
                {
                    Context.HasRight("rshopadministration") &&
                    <Link className="btn btn-primary menuButton" to='/shopadministration'>
                        <i className="fas fa-tasks"></i>
                        <p>{Translation.Trans("administration")}</p>
                    </Link>

                }
                {
                    Context.HasRight("qshopdetail") &&
                    <Link className="btn btn-primary menuButton" to='/shopreportdetails'>
                        <i className="fas fa-info-circle"></i>
                        <p>{Translation.Trans("shopreportdetails")}</p>
                    </Link>
                }
                {
                    Context.HasRight("qshopbrief") &&
                    <Link className="btn btn-primary menuButton" to='/shopreportshort'>
                        <i className="fas fa-info-circle"></i>
                        <p>{Translation.Trans("shopreportshort")}</p>
                    </Link>
                }
                {
                    Context.HasRight("qshoppricereport") &&
                    <Link className="btn btn-primary menuButton" to='/shopreportprice'>
                        <i className="fas fa-info-circle"></i>
                        <p>{Translation.Trans("shopreportprice")}</p>
                    </Link>
                }
                
                {
                    Context.HasRight("rposterminal") &&
                    <Link className="btn btn-primary menuButton" to='/posterminalreport'>
                        <i className="fas fa-credit-card"></i>
                        <p>{Translation.Trans("posterminal")}</p>
                    </Link>
                }

                {
                    Context.HasRight("rrecapperiodreport") &&
                    <Link className="btn btn-primary menuButton" to='/recapperiodreport'>
                        <i className="fas fa-boxes"></i>
                        <p>{Translation.Trans("recapperiodreport")}</p>
                    </Link>
                }
            </div>


        );
    }

}


export default ShopsMenu;


// WEBPACK FOOTER //
// ./src/pages/shopsmenu.js